
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import Button from 'web/components/Button';
import NumberInput from 'web/components/form-elements/NumberInput';
import { StepOneContainer, FormWrapper, } from "web/pages/account/registration/corporate-Registration-Styled";
import { accountActivation } from 'redux/actions/register';
import MembershipPlans from 'web/components/MembershipPlans';
import { register } from 'redux/actions/register';
import SuccessGreenTick from "web/assets/images/success-green-tick.png";

export default ({ props, onSuccessHandler }) => {
    let history = useHistory();
    const dispatch = useDispatch();
    const [componentType, setComponentType] = useState('otpPage');
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const [alertType, setAlertType] = useState('');
    const toggleModal = () => setModal(!modal);
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];

    const [membershipModal, setMembershipModal] = useState(false);
    const membershipToggleModal = () => setMembershipModal(!membershipModal);

    useEffect(() => {
        if (componentType === 'otpPage') inputRefs[0].current.focus();
    }, [])

    const handleInputChange = (e, index) => {
        const value = e.key;
        // if (value.match(/^[0-9]$/) && index >= 0 && index <= 5) {
        if (Number(value) >= 0 && Number(value) <= 9 && index >= 0 && index <= 5) {
            const updatedOTP = [...otp];
            updatedOTP[index] = value;
            setOtp(updatedOTP);

            if (index < 5 && value !== '') {
                inputRefs[index + 1].current.focus();
            }
        } else if (e.key === 'ArrowLeft' && index > 0) {
            inputRefs[index - 1].current.focus();
        } else if (e.key === 'ArrowRight' && index < 5) {
            inputRefs[index + 1].current.focus();
        }
    };

    const handleBackspace = (e, index) => {
        if (e.key === 'Backspace') {
            if (index > 0 || (index === 0 && otp[index] === '')) {
                const updatedOTP = [...otp];
                updatedOTP[index] = '';
                setOtp(updatedOTP);
                inputRefs[Math.max(0, index - 1)].current.focus();
            } else if (index === 0 && otp[index] !== '') {
                const updatedOTP = [...otp];
                updatedOTP[index] = '';
                setOtp(updatedOTP);
            }
        }
    };

    const handleSubmit = async (type) => {
        let data = {
            email: props.values?.email,
            otp: otp.join(''),
        };
        const response = await dispatch(accountActivation(data));
        if (response.data && response.data.status === 'SUCCESS') {
            if(localStorage.getItem('memberShipType')){
                if (localStorage.getItem('memberShipType') === 'guest') guestRegisterApi()
                else if (localStorage.getItem('memberShipType') === 'buyerSeller') onSuccessHandler('buyerSeller')
                else if (localStorage.getItem('memberShipType') === 'broker') onSuccessHandler('broker')
            }else{
                membershipToggleModal()
            }
           
        } else {
            if (response.data.message === "Unauthorized (Invalid token)") {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.data.message);
                setModalLink('');
                toggleModal();
            }
        }
    }

    const membershipPlanFunction = (planType) => {
        membershipToggleModal()
        if (planType === 'guest') guestRegisterApi()
        else if (planType === 'buyerSeller') onSuccessHandler('buyerSeller')
        else if (planType === 'broker') onSuccessHandler('broker')
    }

    const guestRegisterApi = async () => {
        let diverseSpendSelectedListTemp
        if (props.values?.diverseSpendSelectedList && props.values?.diverseSpendSelectedList?.length > 0) {
            diverseSpendSelectedListTemp = props?.values?.diverseSpendSelectedList?.map(data => data.id)
        }
        let businessDesc = (props.values?.businessDesc && props.values?.businessDesc !== "") ? props.values.businessDesc : 'NA'
        let data = {
            basicDetail: {
                name: props.values.name ? props.values.name?.trim() : props.values.name,
                registeredAddress: {
                    line1: props.values.line1 ? props.values.line1?.trim() : props.values.line1,
                    line2: props.values.line2 ? props.values.line2?.trim() : props.values.line2,
                    state: props.values.locationST,
                    city: props.values.locationCity ? props.values.locationCity?.trim() : props.values.locationCity,
                    zip: props.values.locationZip
                },
                phoneNumber: props.values.smsPhNumber,
                companyName: props.values.companyName ? props.values.companyName?.trim() : props.values.companyName,
                email: props.values.email,
                dba: props.values.DBAName,
                diverseTracking: diverseSpendSelectedListTemp ? diverseSpendSelectedListTemp : null,
            },
            accountTypeDTO: {
                buyer: true,
                accountType: 'USER_GUEST'
            },
            companyInfo: {
                businessDesc: businessDesc,
                businessURL: props.values.businessUrl || 'NA',
            },
            hearAbout: props.values.modeOfContact === 'Other' ? props.values.modeOfContactOther : props.values.modeOfContact
        };
        const response = await dispatch(register(data));
        if (response?.data?.status === 'SUCCESS') {
            setComponentType('successfulAlert')
        } else {
            setModalContent(response.data?.message || 'Something went wrong, please try again!');
            setModalLink('');
            toggleModal();
        }
    }

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData('text');
        if (pastedText.length === 6 && pastedText.match(/^[0-9]+$/)) {
            const updatedOTP = pastedText.split('');
            setOtp(updatedOTP);
        }
    };

    return (
        <>
            <StepOneContainer onPaste={handlePaste}>
                {componentType === 'otpPage' &&
                    <FormWrapper>
                        <div style={{ display: 'block', textAlign: 'center' }}>
                            <h6 style={{ fontWeight: 'bold' }}>Verify your email address</h6>
                            <p style={{ padding: '16px 54px', fontSize: '17px' }}>Please input 6 digit OTP sent to your registered email to verify your identify.</p>
                        </div>
                        <div className="otp-input-container">
                            {otp.map((digit, index) => (
                                <input
                                    id={`otp-input-${index}`}
                                    key={index}
                                    type="number"
                                    // type="text"
                                    value={digit}
                                    onKeyUp={(e) => handleInputChange(e, index)}
                                    onKeyDown={(e) => handleBackspace(e, index)}
                                    maxLength="1"
                                    ref={inputRefs[index]} // Assign a ref to the input element
                                />
                            ))}
                        </div>

                        <div className='optButtonStyle'>
                            <Button
                                type="app-green-button submitBtn"
                                disabled={!(otp.filter(val => val !== '').length === 6)}
                                handleClick={() => handleSubmit('web')}
                            >Verify your email
                            </Button>
                        </div>
                    </FormWrapper>
                }

                {componentType === 'successfulAlert' &&
                    <FormWrapper>
                        <div style={{ display: 'block', textAlign: 'center' }}>
                            <img
                                className="success-green-tick"
                                src={SuccessGreenTick}
                                alt="SuccessGreenTick"
                            />
                            <h6 style={{ fontWeight: 'bold' }}>You have registered successfully.</h6>
                        </div>
                        <div className='optButtonStyle'>
                            <Button
                                type="app-green-button submitBtn"
                                handleClick={() => {
                                    localStorage.setItem('guestRegisteredUserEmail', props.values?.email)
                                    history.push('/sign-in')
                                }}
                            >Sign In
                            </Button>
                        </div>
                    </FormWrapper>
                }

                <MembershipPlans
                    isOpen={membershipModal}
                    toggle={membershipToggleModal}
                    pageType="fromRegistration"
                    memeberType="withoutLogin"
                    callBackToRegistration={(val) => membershipPlanFunction(val)}
                />

            </StepOneContainer>

            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=""
                content={modalContent}
                link={modalLink}
                alertType={alertType}
                callBackAlert={() => { }}
            />
        </>
    );
};
